import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, Grid, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown, WorksheetGridFieldSection } from 'Components/Worksheets/Core';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';

let MeasurementsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const penetrations = useSelector(createWorksheetSelector!('Measurements.Penetrations'), deepEquals);
  const getGridData = () => {
    if (!penetrations) return [];
    return penetrations.map((sieveDef: any, index: any) => [
      <Field input={<TextOutput />} name={`Measurements.Penetrations[${index}].TotalBlows`} />,
      <Field input={<NumericInput />} name={`Measurements.Penetrations[${index}].Penetration`} />,
      <Field input={<TextOutput />} name={`Measurements.Penetrations[${index}].ChangeInPenetration`} />,
    ]);
  };

  return (
    <>
      <ListFieldSection>
        <FieldSet>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="mcv-apparatus"
            name="Measurements.MCVApparatus"
          />
          <Field input={<Checkbox />} name="Measurements.DropHeightChecked" />
        </FieldSet>
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="density-mould" name="Measurements.Mould" />

        <Field input={<WorksheetEquipmentDropdown />} equipmentType="caliper" name="Measurements.Calliper" />
      </ListFieldSection>

      <WorksheetGridFieldSection name="Measurements.Penetrations">
        <Grid colHeaders={['Total Blows, n', 'Penetration (mm)', 'Δ Penetration n to 4n (mm)']} data={getGridData()} />
      </WorksheetGridFieldSection>
    </>
  );
};

MeasurementsSection = withInjectedProps(MeasurementsSection);

export { MeasurementsSection };
export default MeasurementsSection;
